import React from 'react';

function SkelBlock({
  w,
  h,
  r,
}: {
  w?: number | string;
  h: number;
  r?: number;
}) {
  return (
    <span
      className="ops-skel-block"
      style={{ width: w ?? '100%', height: h, borderRadius: r ?? 8 }}
    />
  );
}

// Lightweight placeholder shown while the first live payload is in flight, so
// the operator sees the dashboard frame and section layout immediately instead
// of a blank screen.
export function OpsSkeleton() {
  return (
    <div className="ops-skel" aria-hidden>
      <div className="sec-head">
        <SkelBlock w={140} h={13} r={4} />
        <SkelBlock w={220} h={11} r={4} />
      </div>
      <div className="ops-skel-kpis">
        {Array.from({ length: 6 }).map((_, i) => (
          <div className="ops-skel-card" key={i}>
            <SkelBlock w={90} h={12} r={4} />
            <SkelBlock w="60%" h={28} r={6} />
            <SkelBlock w="40%" h={10} r={4} />
          </div>
        ))}
      </div>

      <div className="sec-head" style={{ marginTop: 26 }}>
        <SkelBlock w={120} h={13} r={4} />
      </div>
      <div className="ops-skel-fleet">
        {Array.from({ length: 8 }).map((_, i) => (
          <div className="ops-skel-row" key={i}>
            <SkelBlock w="22%" h={16} r={5} />
            <SkelBlock w="12%" h={16} r={5} />
            <SkelBlock w="10%" h={16} r={5} />
            <SkelBlock w="10%" h={16} r={5} />
            <SkelBlock w="14%" h={16} r={5} />
          </div>
        ))}
      </div>
    </div>
  );
}
